import { render, staticRenderFns } from "./wmsOrderCenter.vue?vue&type=template&id=ff043260"
import script from "./wmsOrderCenter.vue?vue&type=script&lang=js"
export * from "./wmsOrderCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports